import { getCookie } from '@susu/cookie'

export const getCustomerProperties = (): {
  isLoggedIn: string
  customerId: string
} => {
  const isLoggedIn = getCookie('isLoggedIn') === 'true' ? 'true' : 'false'
  const customerId = isLoggedIn === 'true' ? (getCookie('uid') ?? '') : ''

  return {
    isLoggedIn,
    customerId,
  }
}
